/**
 * E-mail pronto para a administradora (0.1.89) — usado na convocação de assembleia e nas
 * cobranças de reserva.
 *
 * O "mailto:" sozinho não servia: abre o programa de e-mail PADRÃO do Windows, e quem usa o
 * Gmail/Outlook pelo navegador não tem nenhum (o clique "não faz nada"). Agora há botões
 * para o Gmail e o Outlook na web, além do programa do computador e de copiar o texto.
 * Nenhum site consegue ANEXAR arquivo sozinho (o navegador não deixa): o PDF é baixado
 * antes e o síndico anexa — a tela diz isso.
 *
 * Com ``pdfUrl``, qualquer botão de e-mail BAIXA o PDF para a pasta Downloads antes de abrir
 * o e-mail (no teste do Airton o PDF não descia: ele abriu o Gmail direto, esperando o anexo).
 */
import { useState } from "react";
import { Copy, Mail } from "lucide-react";

export function linksEmail(assunto: string, corpo: string) {
  const s = encodeURIComponent(assunto), b = encodeURIComponent(corpo);
  return {
    gmail: `https://mail.google.com/mail/?view=cm&fs=1&su=${s}&body=${b}`,
    outlook: `https://outlook.live.com/mail/0/deeplink/compose?subject=${s}&body=${b}`,
    programa: `mailto:?subject=${s}&body=${b}`,
  };
}

/** Baixa um arquivo do próprio site para a pasta Downloads (sem abrir aba). */
export function baixarArquivo(url: string) {
  const a = document.createElement("a");
  a.href = url;
  a.download = "";
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

const BTN = "inline-flex items-center gap-1 px-2.5 py-1 rounded-md border border-slate-300 bg-white hover:bg-slate-50 disabled:opacity-50";

/** Botões: Gmail, Outlook, programa do computador e copiar. ``onUsar`` = registra o envio. */
export function BotoesEmail({ assunto, corpo, onUsar, pdfUrl }: {
  assunto?: string; corpo?: string; onUsar?: () => void; pdfUrl?: string;
}) {
  const [copiado, setCopiado] = useState(false);
  const usar = () => { if (pdfUrl) baixarArquivo(pdfUrl); onUsar?.(); };
  const pronto = !!assunto && !!corpo;
  const l = pronto ? linksEmail(assunto!, corpo!) : null;
  async function copiar() {
    if (!pronto) return;
    usar();
    try {
      await navigator.clipboard.writeText(`${assunto}\n\n${corpo}`);
      setCopiado(true); setTimeout(() => setCopiado(false), 2500);
    } catch { /* sem permissão: o texto fica visível abaixo para copiar à mão */ }
  }
  return (
    <span className="inline-flex flex-wrap gap-1.5">
      <a href={l?.gmail ?? "#"} target="_blank" rel="noreferrer" onClick={usar}
        className={`${BTN} ${pronto ? "" : "pointer-events-none opacity-50"}`}><Mail size={13} /> Abrir no Gmail</a>
      <a href={l?.outlook ?? "#"} target="_blank" rel="noreferrer" onClick={usar}
        className={`${BTN} ${pronto ? "" : "pointer-events-none opacity-50"}`}><Mail size={13} /> Abrir no Outlook</a>
      <a href={l?.programa ?? "#"} onClick={usar}
        className={`${BTN} ${pronto ? "" : "pointer-events-none opacity-50"}`} title="Programa de e-mail instalado no computador">
        <Mail size={13} /> Programa de e-mail</a>
      <button onClick={copiar} disabled={!pronto} className={BTN}>
        <Copy size={13} /> {copiado ? "Texto copiado!" : "Copiar o texto"}
      </button>
    </span>
  );
}

export const AVISO_ANEXO =
  "Ao abrir o e-mail, o PDF é baixado para a sua pasta Downloads. O e-mail abre já escrito, "
  + "mas sem anexo (nenhum site consegue anexar arquivo sozinho): clique no clipe (Anexar) do "
  + "e-mail e escolha o PDF que acabou de baixar.";
